import * as React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {setBodyId, clearBodyClasses} from '../../dom';

import {ListPageRoute} from '../email-marketing/routes/list-page-route';
import {PageWrapper} from '../layout/page-wrapper';

import {EmailAutomationsPage} from './automations/email-automations-page';
import {EmailPage} from './email-page';
import {EmailPageSidebar} from './email-page-sidebar';
import {EmailGoogleExtensionPage} from './extensions/email-google-extension-page';
import {EmailOutlookExtensionPage} from './extensions/email-outlook-extension-page';
import {MailboxRoot} from './mailbox/mailbox-root';
import {EmailTemplatesPage} from './templates/email-templates-page';
import {TemplateGroupsPage} from './templates/template-groups/template-groups-page';

const MAILBOX_PATHS = ['/email/inbox', '/email/sent', '/email/scheduled', '/email/failed'];

export function EmailRoot(props: ContextRouter) {
    return (
        <PageWrapper
            sidebar={<EmailPageSidebar />}
            // Ideally we could set this inside the MailboxRoot, but it has to be done here for now. :(
            // It needs to be at this higher level, because the header has so many buttons and is wide.
            minWidth={
                MAILBOX_PATHS.some((path) => props.location.pathname.includes(path))
                    ? 700
                    : undefined
            }
        >
            <Switch>
                <Route
                    path={MAILBOX_PATHS}
                    render={() => {
                        clearBodyClasses();
                        setBodyId('email');

                        return <MailboxRoot />;
                    }}
                />
                <Route
                    path='/email/templates'
                    exact={true}
                    render={(renderProps) => {
                        return (
                            <ListPageRoute
                                path={renderProps.match.path}
                                defaultQuery={
                                    // Default view is user's own templates
                                    `?filter%5BjustMine%5D=true`
                                }
                                localStorageKey='email-template-groups'
                                includeHash={true}
                                component={TemplateGroupsPage}
                            />
                        );
                    }}
                />
                <Route
                    path='/email/templates/:type/:action?'
                    render={(renderProps) => {
                        return <EmailTemplatesPage {...renderProps} />;
                    }}
                />
                <Route
                    path='/email/automations/:status'
                    render={(renderProps) => {
                        return <EmailAutomationsPage {...renderProps} />;
                    }}
                />
                <Route
                    path='/email/google'
                    render={() => {
                        return <EmailGoogleExtensionPage />;
                    }}
                />
                <Route
                    path='/email/outlook'
                    render={() => {
                        return <EmailOutlookExtensionPage />;
                    }}
                />
                {/* this is a catch-all, make sure it comes at the end */}
                <Route
                    path='/email/:emailId'
                    render={(routeProps) => {
                        clearBodyClasses();
                        setBodyId('email');

                        return routeProps.match.params.emailId ? (
                            <EmailPage emailId={routeProps.match.params.emailId} />
                        ) : (
                            <Redirect to='/email/inbox' />
                        );
                    }}
                />
            </Switch>
        </PageWrapper>
    );
}
